import React, { Component } from 'react';

class Backdrop extends Component {

  componentWillReceiveProps(nextProps) {
	if (nextProps.showBackdrop && !this.props.showBackdrop) {
		this.backdropEl.style.display = 'block';
		this.backdropEl.classList.add('in');
	}
	if (!nextProps.showBackdrop && this.props.showBackdrop) {
		this.backdropEl.classList.remove('in');
		setTimeout(() => {
			this.backdropEl.style.display = 'none';
		}, 600)
	}
  }

  render() {
    return (      
    	<div ref={(el) => { this.backdropEl = el; }} className="modal-backdrop fade" style={{display: 'none'}}></div>
    );
  }
}

export default Backdrop;



/** WEBPACK FOOTER **
 ** ./src/modal/Backdrop.js
 **/